export const addHexPrefix = str => str.startsWith('0x') ? str : `0x${str}`;
export const stripHexPrefix = str => str.startsWith('0x') ? str.substring(2) : str;
//# sourceMappingURL=hexPrefix.js.map